import i18n from "../i18n/index.js";

// Etiqueta visible del "tipo" (origen) de un pedido.
//
// Los pedidos creados a mano quedan en la base como `type: "OTS"`, pero en el
// front NUNCA deben mostrarse como "OTS": se muestran como "Manual". El valor
// "OTS" se conserva tal cual en la base y en los filtros que van al backend;
// esta función SOLO traduce la cadena que ve el usuario.
//
// Úsala en los puntos que renderizan el `package.type` crudo (badges, columnas
// de export, ejes de gráficos de dashboard, etc.). Los listados que ya traen su
// propio mapa de marca (ModernOrdersList, evidenceView, downloadVoucher) cambian
// la entrada OTS -> "Manual" directamente en ese mapa.

export const orderTypeLabel = (type) => {
  if (typeof type === "string" && type.trim().toUpperCase() === "OTS") {
    return i18n.t("Manual");
  }
  return type;
};

export default orderTypeLabel;
